import request from '@/units/request'


/**
 * errCode:
 * 10000: 判断用户是否参加活动 请求出错
 * 10001：用户参与活动 请求出错
 * 10002：获取用户邀请想起信息 出错
 * 10003：填写邀请码请求 出错
 * 10005：微信公众号请求跳转问题
 */

/**
 * 判断用户是否参加活动
 * aid --- 活动ID
 * uid --- 用户ID
 *  */ 
export function join(aid, uid) {
  return request({
    url: `/index/activity/${aid}/user/${uid}`,
    method: 'get',
  })
}

/**
 * 微信公众号跳转
 * aid --- 活动ID
 * code --- 微信redirect
 */
export function wechatRedirect(aid, code) {
  return request({
    url: `/index/activity/${aid}/code/${code}`,
    method: 'get',
  })
}

/**
 * 用户参与活动
 * aid --- 活动ID
 * uid --- 用户ID
 */
export function joinActivity(aid, uid) {
  return request({
    url: `/activity/${aid}/user/${uid}`,
    method: 'post',
  })
}

/**
 * 用户获取自己的活动主页
 * aid --- 活动ID
 * id --- 用户ID
 */
export function getDetail(aid, id) {
  return request({
    url: `/detail/activity/${aid}/personal/${id}`,
    method: 'get',
  })
}

/**
 * 用户填写他人的邀请码
 * aid --- 活动ID
 * uid --- 用户ID
 * code  -- 他人的邀请码
 */
export function submitOtherCode(aid, uid, code) {
  return request({
    url: `/activity/${aid}/user/${uid}/code/${code}`,
    method: 'post',
  })
}

/**
 * 用户填写他人的邀请码
 * aid --- 活动ID
 * uid --- 用户ID
 * code  -- 他人的邀请码
 */
export function getSignature(aid, data) {
  return request({
    url: `/activity/${aid}/signature`,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js